import React, { useContext, useRef } from "react";
import { OwcMenu, OwcListItem } from "@one/react";
import { APP_PATHS, MyLabMenuArray, entryType, equipmentStatus } from "../../constants";
import { useSelector } from "react-redux";
import { ViewChecklist } from "./ViewChecklist";
import { DigitalLabLogbookInstrumentModelType } from "../../models/DigitalLabLogbookInstrumentModelType";
import { useHistory } from "react-router-dom";
import { RootState } from "../../reducers";
import { DialogServiceContext } from "../../utils/hooks/dialogService/DialogServiceContext";

const MyEquipmentMenu = ({
  anchorId,
  setShowMenu,
  logBookEquipment,
  equipmentDetails
}: {
  anchorId: string;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
  logBookEquipment: DigitalLabLogbookInstrumentModelType;
  equipmentDetails: DigitalLabLogbookInstrumentModelType;
}) => {
  const menuElement = useRef(null);

  const dialogService = useContext(DialogServiceContext);
  const history = useHistory();

  const canEdit = useSelector((store: RootState) => store.user.canEdit);
  const redirectWithoutCookie = (inventoryId: any, option: string) => {
    let launchURL = "";
    if (option === "viewLogbook") {
      launchURL = `/cover-sheet/${inventoryId}`;
    }
    window.open(launchURL);
  };

  const handleClick = (option: string) => {
    setShowMenu(false);
    switch (option) {
      case "viewLogbook":
        redirectWithoutCookie(anchorId, option);
        break;
      case "addRunLogs":
        if (logBookEquipment?.entryType === entryType?.standaloneEquipment) {
          sessionStorage.setItem("equipmentIdList", JSON.stringify([equipmentDetails.id]));
          history.push(APP_PATHS.RUN_LOG);
        } else {
          sessionStorage.setItem("equipmentIdList", JSON.stringify([equipmentDetails.id]));
          history.push(APP_PATHS.CLUSTER_RUN_LOG);
        }
        break;
      case "addActionlogs":
        if (logBookEquipment?.entryType === entryType?.standaloneEquipment) {
          sessionStorage.setItem("equipmentIdList", JSON.stringify([equipmentDetails.id]));
          history.push(APP_PATHS.ACTION_LOG);
        } else {
          sessionStorage.setItem("equipmentIdList", JSON.stringify([equipmentDetails.id]));
          history.push(APP_PATHS.CLUSTER_ACTION_LOG);
        }
        break;
      case "viewChecklists":
        dialogService.show({
          title: "Checklists",
          confirmOnly: true,
          confirmText: "Close",
          confirmButtonVariant: "secondary",
          body: <ViewChecklist equipmentDetails={equipmentDetails} />
        });
        break;
      default:
        console.error(`Menu option ${option} not implemented`);
    }
  };

  const getItemDisabledState = (itemKey: string) => {
    switch (itemKey) {
      case "viewLogbook":
        return false;

      case "viewChecklists":
        return logBookEquipment?.status === equipmentStatus?.deleted?.key;

      default:
        return !canEdit || !!logBookEquipment?.clusterId || logBookEquipment?.status === equipmentStatus?.deleted?.key;
    }
  };

  return (
    <div>
      <OwcMenu
        ref={menuElement}
        visible={true}
        onClickOutside={() => setShowMenu(false)}
        anchor={anchorId}
        disable-portal={true}
        strategy="fixed"
        placeholder=""
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
      >
        {MyLabMenuArray.map((item, index) => {
          return (
            <OwcListItem
              key={index}
              onClick={() => {
                handleClick(item.key);
              }}
              id={item.key}
              disabled={getItemDisabledState(item.key)}
              placeholder=""
              onPointerEnterCapture={() => {}}
              onPointerLeaveCapture={() => {}}
            >
              {item.value}
            </OwcListItem>
          );
        })}
      </OwcMenu>
    </div>
  );
};

export default MyEquipmentMenu;
